var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAssets02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 159.99 110.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #f1f1f1;\n      }\n\n      .cls-3 {\n        mask: url(#mask);\n      }\n\n      .cls-4 {\n        fill: #e9e9ea;\n      }\n\n      .cls-5 {\n        fill: #707274;\n      }\n\n      .cls-6 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-7 {\n        fill: #c1c2c3;\n      }\n\n      .cls-8 {\n        fill: #8a8c8e;\n      }\n\n      .cls-9 {\n        fill: #bebfc0;\n      }\n\n      .cls-10 {\n        fill: #dddddf;\n      }\n\n      .cls-11 {\n        fill: #d8d9d9;\n      }\n\n      .cls-12 {\n        fill: #dfdfdf;\n      }\n\n      .cls-13 {\n        fill: #808082;\n      }\n\n      .cls-14 {\n        fill: #acadae;\n      }\n\n      .cls-15 {\n        fill: #bfc0c1;\n      }\n\n      .cls-16 {\n        fill: #a6a7a8;\n      }\n\n      .cls-17 {\n        fill: #edeeee;\n      }\n\n      .cls-18 {\n        fill: #b6b7b8;\n      }\n\n      .cls-19 {\n        fill: #797b7d;\n      }\n\n      .cls-20 {\n        fill: #f9f9fb;\n      }\n\n      .cls-21 {\n        fill: #eaeaea;\n      }\n\n      .cls-22 {\n        fill: #949697;\n      }\n\n      .cls-23 {\n        fill: #b2b3b4;\n      }\n\n      .cls-24 {\n        fill: #e7e8e8;\n      }\n\n      .cls-25 {\n        fill: #a4a6a7;\n      }\n\n      .cls-26 {\n        fill: #e3e3e3;\n      }\n\n      .cls-27 {\n        fill: #ebecec;\n      }\n\n      .cls-28 {\n        fill: #e8e9e9;\n      }\n\n      .cls-29 {\n        fill: #c7c8c9;\n      }\n\n      .cls-30 {\n        fill: #efefef;\n      }\n\n      .cls-31 {\n        fill: #9c9d9f;\n      }\n\n      .cls-32 {\n        fill: #e3e4e4;\n      }\n\n      .cls-33 {\n        fill: #bcbdbe;\n      }\n\n      .cls-34 {\n        fill: #999a9c;\n      }\n\n      .cls-35 {\n        fill: #f6f6f6;\n      }\n\n      .cls-36 {\n        fill: #ebebeb;\n      }\n\n      .cls-37 {\n        fill: #f2f2f3;\n      }\n\n      .cls-38 {\n        fill: #929496;\n      }\n\n      .cls-39 {\n        fill: #a0a2a3;\n      }\n\n      .cls-40 {\n        fill: #f4f4f4;\n      }\n\n      .cls-41 {\n        fill: #b3b4b5;\n      }\n\n      .cls-42 {\n        fill: #8e9091;\n      }\n\n      .cls-43 {\n        fill: #cecece;\n      }\n\n      .cls-44 {\n        fill: #7e8080;\n      }\n\n      .cls-45 {\n        fill: #eeefef;\n      }\n\n      .cls-46 {\n        fill: #a3a4a6;\n      }\n\n      .cls-47 {\n        fill: #a8aaab;\n      }\n\n      .cls-48 {\n        fill: #eaebeb;\n      }\n\n      .cls-49 {\n        fill: #f0f0f1;\n      }\n\n      .cls-50 {\n        fill: #959799;\n      }\n\n      .cls-51 {\n        fill: #919394;\n      }\n\n      .cls-52 {\n        fill: #8f9193;\n      }\n\n      .cls-53 {\n        fill: #858788;\n      }\n\n      .cls-54 {\n        fill: #aeafb0;\n      }\n\n      .cls-55 {\n        fill: #eff0f0;\n      }\n\n      .cls-56 {\n        fill: #f8f9f9;\n      }\n\n      .cls-57 {\n        fill: #b8baba;\n      }\n\n      .cls-58 {\n        fill: #b9babb;\n      }\n\n      .cls-59 {\n        fill: #747678;\n      }\n\n      .cls-60 {\n        fill: #b7b8ba;\n      }\n\n      .cls-61 {\n        fill: #e5e5e5;\n      }\n\n      .cls-62 {\n        fill: #babcbd;\n      }\n\n      .cls-63 {\n        fill: #dadadb;\n      }\n\n      .cls-64 {\n        fill: #f1f2f2;\n      }\n\n      .cls-65 {\n        fill: #838587;\n      }\n\n      .cls-66 {\n        fill: #9b9c9d;\n      }\n\n      .cls-67 {\n        fill: #c8c9ca;\n      }\n\n      .cls-68 {\n        fill: #e0e0e1;\n      }\n\n      .cls-69 {\n        fill: #f7f8f8;\n      }\n\n      .cls-70 {\n        fill: #c2c5c5;\n      }\n\n      .cls-71 {\n        fill: #d3d3d4;\n      }\n\n      .cls-72 {\n        fill: #c4c5c5;\n      }\n\n      .cls-73 {\n        fill: #cecfcf;\n      }\n\n      .cls-74 {\n        fill: #dbdcdc;\n      }\n\n      .cls-75 {\n        fill: #e7e7e7;\n      }\n\n      .cls-76 {\n        fill: #7b7d7f;\n      }\n\n      .cls-77 {\n        fill: #fff;\n      }\n\n      .cls-78 {\n        fill: #8a8b8c;\n      }\n\n      .cls-79 {\n        fill: #888a8b;\n      }\n\n      .cls-80 {\n        fill: #acaeaf;\n      }\n\n      .cls-81 {\n        fill: #eceeee;\n      }\n\n      .cls-82 {\n        fill: #727476;\n      }\n\n      .cls-83 {\n        fill: #6c6e70;\n      }\n\n      .cls-84 {\n        fill: #dcdddd;\n      }\n\n      .cls-85 {\n        fill: #f9f9f9;\n      }\n\n      .cls-86 {\n        fill: #cbcccd;\n      }\n\n      .cls-87 {\n        fill: #f0f0f0;\n      }\n\n      .cls-88 {\n        fill: #818385;\n      }\n\n      .cls-89 {\n        fill: #a1a3a4;\n      }\n\n      .cls-90 {\n        fill: #c5c6c6;\n      }\n\n      .cls-91 {\n        fill: #f3f4f4;\n      }\n\n      .cls-92 {\n        fill: #bdbebf;\n      }\n\n      .cls-93 {\n        fill: #e2e2e3;\n      }\n\n      .cls-94 {\n        fill: #d1d2d2;\n      }\n\n      .cls-95 {\n        fill: #d0d1d1;\n      }\n\n      .cls-96 {\n        fill: #d7d8d8;\n      }\n\n      .cls-97 {\n        fill: #a7a9aa;\n      }\n\n      .cls-98 {\n        fill: #9d9fa0;\n      }\n\n      .cls-99 {\n        fill: #86888a;\n      }\n\n      .cls-100 {\n        fill: #6e7072;\n      }\n\n      .cls-101 {\n        fill: #f8f8f8;\n      }\n\n      .cls-102 {\n        fill: #7d7f80;\n      }\n\n      .cls-103 {\n        opacity: .5;\n      }\n\n      .cls-104 {\n        fill: #f7f7f7;\n      }\n\n      .cls-105 {\n        fill: #c6c7c7;\n      }\n\n      .cls-106 {\n        fill: #e5e7e6;\n      }\n\n      .cls-107 {\n        fill: #d9d9da;\n      }\n\n      .cls-108 {\n        fill: #e6e6e7;\n      }\n\n      .cls-109 {\n        fill: #aaabac;\n      }\n\n      .cls-110 {\n        fill: #f2f2f2;\n      }\n\n      .cls-111 {\n        fill: #b0b2b3;\n      }\n\n      .cls-112 {\n        fill: #e1e2e2;\n      }\n\n      .cls-113 {\n        fill: #f5f5f5;\n      }\n\n      .cls-114 {\n        fill: #f6f7f7;\n      }\n\n      .cls-115 {\n        fill: #d2d3d3;\n      }\n\n      .cls-116 {\n        fill: #9ea0a2;\n      }\n\n      .cls-117 {\n        fill: #e1e1e1;\n      }\n\n      .cls-118 {\n        fill: #cccdce;\n      }\n\n      .cls-119 {\n        fill: #e4e4e5;\n      }\n\n      .cls-120 {\n        fill: #808283;\n      }\n\n      .cls-121 {\n        fill: #f3f3f3;\n      }\n\n      .cls-122 {\n        fill: #fbfbfb;\n      }\n\n      .cls-123 {\n        fill: #dfe0e0;\n      }\n\n      .cls-124 {\n        fill: #8c8e90;\n      }\n\n      .cls-125 {\n        fill: #ffd510;\n      }\n\n      .cls-126 {\n        fill: #cacbcc;\n      }\n\n      .cls-127 {\n        fill: #b4b6b7;\n      }\n\n      .cls-128 {\n        fill: #cfd0d0;\n      }\n\n      .cls-129 {\n        fill: #d4d5d7;\n      }\n\n      .cls-130 {\n        fill: #77797b;\n      }\n\n      .cls-131 {\n        fill: #afb1b2;\n      }\n\n      .cls-132 {\n        fill: #eee;\n      }\n\n      .cls-133 {\n        fill: #6a6c6e;\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-135 {\n        fill: #757779;\n      }\n\n      .cls-136 {\n        fill: #97999a;\n      }\n\n      .cls-137 {\n        fill: #c0c1c2;\n      }\n\n      .cls-138 {\n        fill: #f5f6f6;\n      }\n\n      .cls-139 {\n        fill: #d4d4d5;\n      }\n\n      .cls-140 {\n        fill: #c9cacb;\n      }\n\n      .cls-141 {\n        fill: #d6d7d7;\n      }\n\n      .cls-142 {\n        fill: #e8e8e8;\n      }\n\n      .cls-143 {\n        fill: #d5d7d7;\n      }\n\n      .cls-144 {\n        fill: #dadbdc;\n      }\n\n      .cls-145 {\n        fill: #ececec;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 19.53,
    y: -95.38,
    width: 195.15,
    height: 175.05,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.19,
    y: -57.67,
    width: 154.43,
    height: 99.62,
    transform: "translate(33.1 76.62) rotate(-39.45)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 19.53,
    y: -95.38,
    width: 195.15,
    height: 175.05,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 46.19,
    y: -57.67,
    width: 154.43,
    height: 99.62,
    transform: "translate(33.1 76.62) rotate(-39.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M166.41-68.22c24.22,29.42,13.91,77.93-23.03,108.34-36.94,30.41-86.52,31.21-110.75,1.79C20.52,27.2,17.04,7.72,21.21-11.89L30.55-.54l94.61-77.85-9.36-11.37c20.04-.32,38.49,6.83,50.6,21.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M166.09-67.96c24.11,29.29,13.85,77.57-22.92,107.84-36.77,30.27-86.12,31.07-110.23,1.78C20.88,27.02,17.41,7.63,21.56-11.88L30.75-.71l94.18-77.49-9.21-11.2c19.95-.32,38.32,6.8,50.37,21.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M165.77-67.69c24,29.15,13.78,77.21-22.81,107.34-36.6,30.13-85.72,30.93-109.72,1.77C21.23,26.85,17.78,7.55,21.91-11.88L30.96-.88l93.74-77.13-9.07-11.02c19.86-.32,38.14,6.77,50.14,21.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M165.45-67.43c23.89,29.01,13.72,76.85-22.71,106.84-36.43,29.99-85.32,30.78-109.21,1.77C21.58,26.67,18.15,7.46,22.26-11.87L31.17-1.05l93.3-76.77-8.92-10.85c19.76-.32,37.96,6.74,49.9,21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M165.12-67.16c23.77,28.88,13.66,76.49-22.6,106.34-36.26,29.85-84.92,30.64-108.7,1.76C21.94,26.49,18.53,7.37,22.62-11.87L31.38-1.22l92.86-76.41-8.78-10.67c19.67-.32,37.78,6.7,49.67,21.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M164.8-66.89c23.66,28.74,13.59,76.13-22.49,105.83-36.09,29.71-84.52,30.49-108.18,1.75C22.29,26.32,18.9,7.29,22.97-11.87L31.58-1.39l92.42-76.05-8.64-10.5c19.58-.32,37.6,6.67,49.43,21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M164.48-66.63c23.55,28.61,13.53,75.76-22.39,105.33-35.92,29.57-84.12,30.35-107.67,1.74C22.65,26.14,19.27,7.2,23.32-11.86L31.79-1.56l91.99-75.69-8.49-10.32c19.48-.32,37.42,6.64,49.2,20.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M164.16-66.36c23.44,28.47,13.46,75.4-22.28,104.83-35.74,29.43-83.72,30.2-107.16,1.73C23,25.97,19.64,7.11,23.67-11.86L32-1.73l91.55-75.33-8.35-10.15c19.39-.31,37.25,6.61,48.96,20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M163.84-66.1c23.33,28.33,13.4,75.04-22.17,104.33-35.57,29.29-83.32,30.06-106.65,1.72C23.36,25.79,20.01,7.03,24.02-11.85L32.2-1.9l91.11-74.97-8.2-9.97c19.3-.31,37.07,6.58,48.73,20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M163.52-65.83c23.21,28.2,13.33,74.68-22.07,103.83-35.4,29.15-82.92,29.91-106.13,1.72C23.71,25.61,20.38,6.94,24.37-11.85l8.04,9.77,90.67-74.61-8.06-9.8c19.21-.31,36.89,6.55,48.5,20.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M163.2-65.57c23.1,28.06,13.27,74.32-21.96,103.33-35.23,29-82.52,29.77-105.62,1.71C24.06,25.44,20.75,6.86,24.72-11.84l7.9,9.6,90.23-74.25-7.92-9.62c19.11-.31,36.71,6.51,48.26,20.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M162.88-65.3c22.99,27.92,13.2,73.96-21.86,102.82-35.06,28.86-82.12,29.62-105.11,1.7C24.42,25.26,21.12,6.77,25.07-11.84l7.75,9.42,89.8-73.89-7.77-9.45c19.02-.31,36.53,6.48,48.03,20.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M162.55-65.04c22.88,27.79,13.14,73.6-21.75,102.32-34.89,28.72-81.72,29.48-104.6,1.69C24.77,25.08,21.49,6.68,25.42-11.83l7.61,9.25,89.36-73.53-7.63-9.27c18.93-.31,36.35,6.45,47.79,20.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M162.23-64.77c22.77,27.65,13.08,73.24-21.64,101.82-34.72,28.58-81.32,29.34-104.08,1.68C25.13,24.91,21.86,6.6,25.77-11.83l7.47,9.07,88.92-73.17-7.48-9.1c18.83-.3,36.18,6.42,47.56,20.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M161.91-64.51c22.65,27.52,13.01,72.88-21.54,101.32-34.55,28.44-80.92,29.19-103.57,1.68-11.33-13.76-14.58-31.98-10.68-50.31l7.32,8.9,88.48-72.81-7.34-8.92c18.74-.3,36,6.39,47.32,20.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M161.59-64.24c22.54,27.38,12.95,72.52-21.43,100.82-34.38,28.3-80.52,29.05-103.06,1.67-11.27-13.69-14.51-31.82-10.63-50.06l7.18,8.72,88.04-72.45-7.2-8.75c18.65-.3,35.82,6.36,47.09,20.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M161.27-63.98c22.43,27.24,12.88,72.16-21.32,100.32-34.2,28.16-80.12,28.9-102.54,1.66-11.21-13.62-14.44-31.66-10.58-49.81l7.03,8.55,87.61-72.08-7.05-8.57c18.56-.3,35.64,6.33,46.86,19.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M160.95-63.71c22.32,27.11,12.82,71.8-21.22,99.82-34.03,28.02-79.71,28.76-102.03,1.65-11.16-13.55-14.36-31.5-10.52-49.57l6.89,8.37,87.17-71.72-6.91-8.4c18.46-.3,35.46,6.29,46.62,19.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M160.63-63.44c22.2,26.97,12.75,71.44-21.11,99.31-33.86,27.88-79.31,28.61-101.52,1.64-11.1-13.49-14.29-31.34-10.47-49.32l6.75,8.2,86.73-71.36-6.76-8.22c18.37-.3,35.29,6.26,46.39,19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M160.31-63.18c22.09,26.84,12.69,71.07-21,98.81-33.69,27.74-78.91,28.47-101.01,1.63-11.05-13.42-14.22-31.19-10.42-49.07l6.6,8.02,86.29-71-6.62-8.05c18.28-.3,35.11,6.23,46.15,19.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M159.98-62.91c21.98,26.7,12.62,70.71-20.9,98.31-33.52,27.6-78.51,28.32-100.49,1.63-10.99-13.35-14.15-31.03-10.37-48.82l6.46,7.85,85.85-70.64-6.48-7.87c18.19-.29,34.93,6.2,45.92,19.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M159.66-62.65c21.87,26.56,12.56,70.35-20.79,97.81-33.35,27.46-78.11,28.18-99.98,1.62-10.93-13.28-14.07-30.87-10.31-48.57l6.31,7.67,85.41-70.28-6.33-7.7c18.09-.29,34.75,6.17,45.68,19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M159.34-62.38c21.76,26.43,12.5,69.99-20.68,97.31-33.18,27.32-77.71,28.04-99.47,1.61-10.88-13.21-14-30.71-10.26-48.32l6.17,7.5,84.98-69.92-6.19-7.52c18-.29,34.57,6.14,45.45,19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M159.02-62.12c21.64,26.29,12.43,69.63-20.58,96.81-33.01,27.17-77.31,27.89-98.95,1.6-10.82-13.15-13.93-30.55-10.21-48.07l6.03,7.32,84.54-69.56-6.04-7.35c17.91-.29,34.39,6.1,45.22,19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M158.7-61.85c21.53,26.15,12.37,69.27-20.47,96.3-32.84,27.03-76.91,27.75-98.44,1.59-10.77-13.08-13.86-30.39-10.15-47.82l5.88,7.15,84.1-69.2-5.9-7.17c17.81-.29,34.22,6.07,44.98,19.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M158.38-61.59c21.42,26.02,12.3,68.91-20.36,95.8-32.67,26.89-76.51,27.6-97.93,1.58-10.71-13.01-13.79-30.24-10.1-47.57l5.74,6.97,83.66-68.84-5.76-7c17.72-.29,34.04,6.04,44.75,19.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M158.06-61.32c21.31,25.88,12.24,68.55-20.26,95.3-32.49,26.75-76.11,27.46-97.42,1.58-10.65-12.94-13.71-30.08-10.05-47.32l5.59,6.8,83.22-68.48-5.61-6.82c17.63-.29,33.86,6.01,44.51,18.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M157.73-61.06c21.2,25.75,12.17,68.19-20.15,94.8-32.32,26.61-75.71,27.31-96.9,1.57-10.6-12.87-13.64-29.92-9.99-47.07l5.45,6.62,82.79-68.12-5.47-6.65c17.54-.28,33.68,5.98,44.28,18.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M157.41-60.79c21.08,25.61,12.11,67.83-20.04,94.3-32.15,26.47-75.31,27.17-96.39,1.56-10.54-12.8-13.57-29.76-9.94-46.83l5.31,6.45,82.35-67.76-5.32-6.47c17.44-.28,33.5,5.95,44.04,18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M157.09-60.53c20.97,25.47,12.05,67.47-19.94,93.8-31.98,26.33-74.91,27.02-95.88,1.55-10.49-12.74-13.5-29.6-9.89-46.58l5.16,6.27,81.91-67.4-5.18-6.3c17.35-.28,33.32,5.91,43.81,18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M156.77-60.26c20.86,25.34,11.98,67.11-19.83,93.29-31.81,26.19-74.51,26.88-95.37,1.54-10.43-12.67-13.42-29.44-9.84-46.33l5.02,6.1,81.47-67.04-5.04-6.12c17.26-.28,33.15,5.88,43.58,18.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M156.45-59.99c20.75,25.2,11.92,66.74-19.72,92.79-31.64,26.05-74.11,26.73-94.85,1.53-10.37-12.6-13.35-29.29-9.78-46.08l4.87,5.92,81.03-66.68-4.89-5.95c17.17-.28,32.97,5.85,43.34,18.45Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-122",
    cx: 99.15,
    cy: -12.82,
    rx: 73.8,
    ry: 58.78,
    transform: "translate(30.75 60.1) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 99.14,
    cy: -12.81,
    rx: 73.4,
    ry: 58.46,
    transform: "translate(30.74 60.09) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-85",
    cx: 99.13,
    cy: -12.8,
    rx: 73,
    ry: 58.14,
    transform: "translate(30.73 60.09) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M155.16-58.93c20.3,24.66,11.66,65.3-19.3,90.79-30.96,25.48-72.5,26.16-92.8,1.5C22.77,8.7,31.41-31.95,62.36-57.43c30.96-25.48,72.5-26.16,92.8-1.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-85",
    cx: 99.1,
    cy: -12.78,
    rx: 72.2,
    ry: 57.51,
    transform: "translate(30.71 60.08) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-85",
    cx: 99.09,
    cy: -12.77,
    rx: 71.8,
    ry: 57.19,
    transform: "translate(30.71 60.07) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 99.08,
    cy: -12.76,
    rx: 71.4,
    ry: 56.87,
    transform: "translate(30.7 60.07) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M153.88-57.87c19.85,24.11,11.4,63.86-18.87,88.78-30.27,24.92-70.9,25.58-90.75,1.47-19.85-24.11-11.4-63.86,18.87-88.78,30.27-24.92,70.9-25.58,90.75-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M153.56-57.61c19.74,23.97,11.34,63.5-18.76,88.28-30.1,24.78-70.5,25.43-90.24,1.46-19.74-23.97-11.34-63.5,18.76-88.28,30.1-24.78,70.5-25.43,90.24-1.46Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-101",
    cx: 99.05,
    cy: -12.73,
    rx: 70.19,
    ry: 55.91,
    transform: "translate(30.67 60.05) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-69",
    cx: 99.03,
    cy: -12.72,
    rx: 69.79,
    ry: 55.59,
    transform: "translate(30.66 60.05) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M152.59-56.81c19.4,23.57,11.14,62.42-18.44,86.77-29.59,24.36-69.3,25-88.7,1.43C26.05,7.83,34.31-31.02,63.89-55.37c29.59-24.36,69.3-25,88.7-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M152.27-56.54c19.29,23.43,11.08,62.05-18.34,86.27-29.42,24.22-68.9,24.86-88.19,1.43-19.29-23.43-11.08-62.05,18.34-86.27,29.42-24.22,68.9-24.86,88.19-1.43Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-104",
    cx: 99,
    cy: -12.68,
    rx: 68.59,
    ry: 54.63,
    transform: "translate(30.63 60.03) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-114",
    cx: 98.99,
    cy: -12.67,
    rx: 68.19,
    ry: 54.31,
    transform: "translate(30.62 60.03) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 98.98,
    cy: -12.66,
    rx: 67.79,
    ry: 53.99,
    transform: "translate(30.61 60.02) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 98.96,
    cy: -12.65,
    rx: 67.39,
    ry: 53.67,
    transform: "translate(30.6 60.02) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-138",
    cx: 98.95,
    cy: -12.64,
    rx: 66.98,
    ry: 53.35,
    transform: "translate(30.59 60.01) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M150.35-54.95c18.62,22.61,10.69,59.89-17.7,83.26-28.39,23.37-66.5,23.99-85.11,1.38-18.62-22.61-10.69-59.89,17.7-83.26,28.39-23.37,66.5-23.99,85.11-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M150.02-54.69c18.5,22.48,10.63,59.53-17.59,82.76-28.22,23.23-66.09,23.84-84.6,1.37-18.5-22.48-10.63-59.53,17.59-82.76,28.22-23.23,66.1-23.84,84.6-1.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-113",
    cx: 98.92,
    cy: -12.61,
    rx: 65.78,
    ry: 52.39,
    transform: "translate(30.57 60) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 98.91,
    cy: -12.6,
    rx: 65.38,
    ry: 52.07,
    transform: "translate(30.56 59.99) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 98.89,
    cy: -12.59,
    rx: 64.98,
    ry: 51.76,
    transform: "translate(30.55 59.99) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M148.74-53.63c18.06,21.93,10.37,58.09-17.16,80.76-27.53,22.67-64.49,23.27-82.55,1.34-18.06-21.93-10.37-58.09,17.16-80.75,27.53-22.67,64.49-23.27,82.55-1.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-121",
    cx: 98.87,
    cy: -12.57,
    rx: 64.18,
    ry: 51.12,
    transform: "translate(30.53 59.98) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-121",
    cx: 98.86,
    cy: -12.56,
    rx: 63.78,
    ry: 50.8,
    transform: "translate(30.52 59.97) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 98.85,
    cy: -12.55,
    rx: 63.37,
    ry: 50.48,
    transform: "translate(30.51 59.97) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M147.45-52.56c17.61,21.39,10.11,56.64-16.74,78.75-26.85,22.11-62.89,22.69-80.5,1.3-17.61-21.39-10.11-56.64,16.74-78.75,26.85-22.11,62.89-22.69,80.5-1.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-64",
    cx: 98.82,
    cy: -12.53,
    rx: 62.57,
    ry: 49.84,
    transform: "translate(30.49 59.96) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 98.81,
    cy: -12.52,
    rx: 62.17,
    ry: 49.52,
    transform: "translate(30.48 59.95) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 98.8,
    cy: -12.51,
    rx: 61.77,
    ry: 49.2,
    transform: "translate(30.47 59.95) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M146.17-51.5c17.16,20.84,9.86,55.2-16.31,76.74-26.17,21.54-61.29,22.11-78.45,1.27-17.16-20.84-9.86-55.2,16.31-76.74,26.17-21.54,61.29-22.11,78.45-1.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-87",
    cx: 98.78,
    cy: -12.49,
    rx: 60.97,
    ry: 48.56,
    transform: "translate(30.45 59.94) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 98.77,
    cy: -12.48,
    rx: 60.57,
    ry: 48.24,
    transform: "translate(30.44 59.93) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 98.76,
    cy: -12.47,
    rx: 60.17,
    ry: 47.92,
    transform: "translate(30.44 59.93) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 98.74,
    cy: -12.45,
    rx: 59.76,
    ry: 47.6,
    transform: "translate(30.43 59.92) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M144.56-50.17c16.6,20.16,9.53,53.4-15.78,74.23-25.31,20.84-59.29,21.39-75.88,1.23-16.6-20.16-9.53-53.4,15.78-74.23,25.31-20.84,59.29-21.39,75.88-1.23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 98.72,
    cy: -12.43,
    rx: 58.96,
    ry: 46.96,
    transform: "translate(30.41 59.91) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M143.92-49.64c16.37,19.89,9.4,52.67-15.56,73.23-24.97,20.56-58.48,21.1-74.86,1.21-16.37-19.89-9.4-52.67,15.57-73.23,24.97-20.56,58.48-21.1,74.86-1.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-81",
    cx: 98.7,
    cy: -12.41,
    rx: 58.16,
    ry: 46.32,
    transform: "translate(30.39 59.9) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-145",
    cx: 98.69,
    cy: -12.4,
    rx: 57.76,
    ry: 46,
    transform: "translate(30.38 59.9) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 98.67,
    cy: -12.39,
    rx: 57.36,
    ry: 45.69,
    transform: "translate(30.37 59.89) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 98.66,
    cy: -12.38,
    rx: 56.96,
    ry: 45.37,
    transform: "translate(30.36 59.89) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 98.65,
    cy: -12.37,
    rx: 56.56,
    ry: 45.05,
    transform: "translate(30.35 59.88) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 98.64,
    cy: -12.36,
    rx: 56.15,
    ry: 44.73,
    transform: "translate(30.34 59.88) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 98.63,
    cy: -12.35,
    rx: 55.75,
    ry: 44.41,
    transform: "translate(30.33 59.87) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M141.35-47.52c15.48,18.8,8.89,49.79-14.71,69.22-23.6,19.43-55.28,19.94-70.76,1.14-15.48-18.8-8.89-49.79,14.71-69.22,23.6-19.43,55.28-19.94,70.76-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M141.03-47.26c15.36,18.66,8.82,49.43-14.61,68.72-23.43,19.29-54.88,19.8-70.24,1.14-15.36-18.66-8.82-49.43,14.61-68.72,23.43-19.29,54.88-19.8,70.24-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M140.71-46.99c15.25,18.53,8.76,49.07-14.5,68.22-23.26,19.15-54.48,19.65-69.73,1.13-15.25-18.53-8.76-49.07,14.5-68.22,23.26-19.15,54.48-19.65,69.73-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M140.39-46.72c15.14,18.39,8.7,48.71-14.39,67.71-23.09,19.01-54.08,19.51-69.22,1.12-15.14-18.39-8.7-48.71,14.39-67.71,23.09-19.01,54.08-19.51,69.22-1.12Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-108",
    cx: 98.57,
    cy: -12.3,
    rx: 53.75,
    ry: 42.81,
    transform: "translate(30.29 59.85) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 98.56,
    cy: -12.29,
    rx: 53.35,
    ry: 42.49,
    transform: "translate(30.28 59.84) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-61",
    cx: 98.55,
    cy: -12.28,
    rx: 52.95,
    ry: 42.17,
    transform: "translate(30.27 59.84) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M139.1-45.66c14.69,17.84,8.44,47.26-13.97,65.71-22.4,18.44-52.48,18.93-67.17,1.09-14.69-17.84-8.44-47.26,13.97-65.71,22.4-18.44,52.48-18.93,67.17-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M138.78-45.4c14.58,17.71,8.37,46.9-13.86,65.21-22.23,18.3-52.07,18.79-66.65,1.08-14.58-17.71-8.37-46.9,13.86-65.21,22.23-18.3,52.07-18.79,66.65-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M138.46-45.13c14.47,17.57,8.31,46.54-13.75,64.7-22.06,18.16-51.67,18.64-66.14,1.07-14.47-17.57-8.31-46.54,13.75-64.7,22.06-18.16,51.67-18.64,66.14-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M138.14-44.87c14.35,17.44,8.25,46.18-13.65,64.2-21.89,18.02-51.27,18.5-65.63,1.06-14.35-17.44-8.24-46.18,13.65-64.2s51.27-18.5,65.63-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M137.82-44.6c14.24,17.3,8.18,45.82-13.54,63.7-21.72,17.88-50.87,18.35-65.12,1.05-14.24-17.3-8.18-45.82,13.54-63.7,21.72-17.88,50.87-18.35,65.12-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M137.49-44.34c14.13,17.16,8.12,45.46-13.43,63.2-21.55,17.74-50.47,18.21-64.6,1.05-14.13-17.16-8.12-45.46,13.43-63.2,21.55-17.74,50.47-18.21,64.6-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M137.17-44.07c14.02,17.03,8.05,45.1-13.33,62.7-21.38,17.6-50.07,18.06-64.09,1.04-14.02-17.03-8.05-45.1,13.33-62.7,21.38-17.6,50.07-18.06,64.09-1.04Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-123",
    cx: 98.45,
    cy: -12.19,
    rx: 49.74,
    ry: 39.62,
    transform: "translate(30.19 59.8) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 98.44,
    cy: -12.18,
    rx: 49.34,
    ry: 39.3,
    transform: "translate(30.18 59.79) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M136.21-43.27c13.68,16.62,7.86,44.02-13.01,61.19-20.86,17.18-48.87,17.63-62.55,1.01-13.68-16.62-7.86-44.02,13.01-61.19,20.86-17.18,48.87-17.63,62.55-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135.89-43.01c13.57,16.48,7.79,43.66-12.9,60.69-20.69,17.04-48.47,17.49-62.04,1-13.57-16.48-7.79-43.65,12.9-60.69,20.69-17.04,48.47-17.49,62.04-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M135.57-42.74c13.46,16.35,7.73,43.29-12.79,60.19-20.52,16.9-48.07,17.34-61.53,1-13.46-16.35-7.73-43.29,12.79-60.19,20.52-16.9,48.07-17.34,61.53-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M135.25-42.48c13.35,16.21,7.66,42.93-12.69,59.69-20.35,16.75-47.67,17.2-61.01.99-13.35-16.21-7.67-42.93,12.69-59.69s47.67-17.2,61.01-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M134.92-42.21c13.23,16.07,7.6,42.57-12.58,59.19-20.18,16.61-47.27,17.05-60.5.98-13.23-16.07-7.6-42.57,12.58-59.19,20.18-16.61,47.27-17.05,60.5-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M134.6-41.95c13.12,15.94,7.54,42.21-12.47,58.68-20.01,16.47-46.87,16.91-59.99.97-13.12-15.94-7.54-42.21,12.47-58.69,20.01-16.47,46.87-16.91,59.99-.97Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-107",
    cx: 98.36,
    cy: -12.11,
    rx: 46.53,
    ry: 37.06,
    transform: "translate(30.12 59.76) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 98.35,
    cy: -12.1,
    rx: 46.13,
    ry: 36.74,
    transform: "translate(30.11 59.75) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M133.64-41.15c12.78,15.53,7.34,41.13-12.15,57.18-19.5,16.05-45.67,16.47-58.45.95-12.78-15.53-7.34-41.13,12.15-57.18,19.5-16.05,45.67-16.47,58.45-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M133.32-40.89c12.67,15.39,7.28,40.77-12.05,56.68-19.33,15.91-45.27,16.33-57.94.94-12.67-15.39-7.28-40.77,12.05-56.68,19.33-15.91,45.27-16.33,57.94-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M133-40.62c12.56,15.26,7.21,40.41-11.94,56.18-19.15,15.77-44.86,16.19-57.42.93-12.56-15.26-7.21-40.41,11.94-56.18,19.15-15.77,44.86-16.19,57.42-.93Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-129",
    cx: 98.3,
    cy: -12.06,
    rx: 44.52,
    ry: 35.46,
    transform: "translate(30.07 59.73) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M132.35-40.09c12.34,14.98,7.09,39.69-11.73,55.17-18.81,15.49-44.06,15.9-56.4.91-12.34-14.98-7.09-39.69,11.73-55.17,18.81-15.49,44.06-15.9,56.4-.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-71",
    cx: 98.28,
    cy: -12.04,
    rx: 43.72,
    ry: 34.82,
    transform: "translate(30.06 59.72) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M131.71-39.56c12.11,14.71,6.96,38.97-11.51,54.17-18.47,15.21-43.26,15.61-55.37.9-12.11-14.71-6.96-38.96,11.51-54.17,18.47-15.21,43.26-15.61,55.37-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M131.39-39.29c12,14.58,6.89,38.6-11.41,53.67-18.3,15.07-42.86,15.46-54.86.89-12-14.58-6.89-38.6,11.41-53.67,18.3-15.07,42.86-15.46,54.86-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M131.07-39.03c11.89,14.44,6.83,38.24-11.3,53.17-18.13,14.92-42.46,15.32-54.35.88-11.89-14.44-6.83-38.24,11.3-53.17,18.13-14.92,42.46-15.32,54.35-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M130.75-38.76c11.78,14.3,6.76,37.88-11.19,52.67-17.96,14.78-42.06,15.17-53.84.87-11.78-14.3-6.76-37.88,11.19-52.67,17.96-14.78,42.06-15.17,53.84-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M130.43-38.5c11.66,14.17,6.7,37.52-11.09,52.16-17.79,14.64-41.66,15.03-53.32.86-11.66-14.17-6.7-37.52,11.09-52.16,17.79-14.64,41.66-15.03,53.32-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M130.1-38.23c11.55,14.03,6.63,37.16-10.98,51.66-17.62,14.5-41.26,14.88-52.81.85-11.55-14.03-6.63-37.16,10.98-51.66,17.62-14.5,41.26-14.88,52.81-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M129.78-37.97c11.44,13.89,6.57,36.8-10.87,51.16-17.44,14.36-40.86,14.74-52.3.85-11.44-13.89-6.57-36.8,10.87-51.16,17.44-14.36,40.86-14.74,52.3-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M129.46-37.7c11.33,13.76,6.51,36.44-10.77,50.66-17.27,14.22-40.46,14.6-51.78.84C55.58.04,60.4-22.64,77.68-36.86c17.27-14.22,40.46-14.6,51.78-.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-126",
    cx: 98.17,
    cy: -11.94,
    rx: 40.11,
    ry: 31.95,
    transform: "translate(29.97 59.68) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-140",
    cx: 98.16,
    cy: -11.93,
    rx: 39.71,
    ry: 31.63,
    transform: "translate(29.96 59.67) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M128.5-36.91c10.99,13.35,6.31,35.36-10.45,49.16-16.76,13.8-39.26,14.16-50.25.81-10.99-13.35-6.31-35.36,10.45-49.16,16.76-13.8,39.26-14.16,50.25-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M128.18-36.64c10.88,13.21,6.25,35-10.34,48.65-16.59,13.66-38.86,14.02-49.73.8-10.88-13.21-6.25-35,10.34-48.65,16.59-13.66,38.86-14.02,49.73-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M127.86-36.37c10.77,13.08,6.18,34.64-10.23,48.15-16.42,13.52-38.46,13.87-49.22.8-10.77-13.08-6.18-34.64,10.23-48.15,16.42-13.52,38.46-13.87,49.22-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M127.53-36.11c10.65,12.94,6.12,34.27-10.13,47.65-16.25,13.38-38.05,13.73-48.71.79-10.65-12.94-6.12-34.27,10.13-47.65,16.25-13.38,38.05-13.73,48.71-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M127.21-35.84c10.54,12.8,6.05,33.91-10.02,47.15-16.08,13.23-37.65,13.58-48.2.78-10.54-12.8-6.05-33.91,10.02-47.15,16.08-13.24,37.65-13.58,48.2-.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 98.09,
    cy: -11.87,
    rx: 37.3,
    ry: 29.71,
    transform: "translate(29.91 59.64) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126.57-35.31c10.32,12.53,5.93,33.19-9.81,46.15-15.73,12.95-36.85,13.29-47.17.76-10.32-12.53-5.93-33.19,9.81-46.15,15.73-12.95,36.85-13.3,47.17-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M126.25-35.05c10.21,12.4,5.86,32.83-9.7,45.64-15.56,12.81-36.45,13.15-46.66.75-10.21-12.4-5.86-32.83,9.7-45.64,15.56-12.81,36.45-13.15,46.66-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M125.93-34.78c10.09,12.26,5.8,32.47-9.59,45.14-15.39,12.67-36.05,13.01-46.15.75-10.09-12.26-5.8-32.47,9.6-45.14,15.39-12.67,36.05-13.01,46.14-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.61-34.52c9.98,12.12,5.73,32.11-9.49,44.64-15.22,12.53-35.65,12.86-45.63.74-9.98-12.12-5.73-32.11,9.49-44.64,15.22-12.53,35.65-12.86,45.63-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M125.29-34.25c9.87,11.99,5.67,31.75-9.38,44.14-15.05,12.39-35.25,12.72-45.12.73-9.87-11.99-5.67-31.75,9.38-44.14,15.05-12.39,35.25-12.72,45.12-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M124.96-33.99c9.76,11.85,5.6,31.39-9.27,43.64-14.88,12.25-34.85,12.57-44.61.72-9.76-11.85-5.6-31.39,9.28-43.64,14.88-12.25,34.85-12.57,44.61-.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-62",
    cx: 98.01,
    cy: -11.8,
    rx: 34.49,
    ry: 27.47,
    transform: "translate(29.84 59.61) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M124.32-33.46c9.53,11.58,5.48,30.67-9.06,42.63-14.54,11.97-34.05,12.28-43.58.71-9.53-11.58-5.48-30.67,9.06-42.63,14.54-11.97,34.05-12.28,43.58-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M124-33.19c9.42,11.44,5.41,30.31-8.96,42.13-14.37,11.83-33.65,12.14-43.07.7-9.42-11.44-5.41-30.31,8.96-42.13,14.37-11.83,33.65-12.14,43.07-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M123.68-32.92c9.31,11.31,5.35,29.95-8.85,41.63-14.19,11.69-33.25,11.99-42.56.69s-5.35-29.95,8.85-41.63c14.2-11.69,33.25-11.99,42.56-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M123.36-32.66c9.2,11.17,5.28,29.58-8.74,41.13-14.02,11.55-32.85,11.85-42.04.68-9.2-11.17-5.28-29.58,8.74-41.13,14.02-11.55,32.85-11.85,42.04-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M123.04-32.39c9.08,11.03,5.22,29.22-8.64,40.63-13.85,11.4-32.45,11.71-41.53.67-9.08-11.03-5.22-29.22,8.64-40.63,13.85-11.4,32.45-11.71,41.53-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M122.72-32.13c8.97,10.9,5.15,28.86-8.53,40.13-13.68,11.26-32.05,11.56-41.02.66-8.97-10.9-5.15-28.86,8.53-40.13,13.68-11.26,32.05-11.56,41.02-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M122.39-31.86c8.86,10.76,5.09,28.5-8.42,39.62-13.51,11.12-31.65,11.42-40.51.66-8.86-10.76-5.09-28.5,8.42-39.62,13.51-11.12,31.65-11.42,40.5-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M122.07-31.6c8.75,10.62,5.02,28.14-8.32,39.12-13.34,10.98-31.24,11.27-39.99.65-8.75-10.63-5.02-28.14,8.32-39.12,13.34-10.98,31.24-11.27,39.99-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M121.75-31.33c8.64,10.49,4.96,27.78-8.21,38.62-13.17,10.84-30.84,11.13-39.48.64-8.64-10.49-4.96-27.78,8.21-38.62,13.17-10.84,30.84-11.13,39.48-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M121.43-31.07c8.52,10.35,4.9,27.42-8.1,38.12-13,10.7-30.44,10.98-38.97.63-8.52-10.35-4.9-27.42,8.1-38.12,13-10.7,30.44-10.98,38.97-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M121.11-30.8c8.41,10.22,4.83,27.06-8,37.62-12.83,10.56-30.04,10.84-38.45.62-8.41-10.22-4.83-27.06,8-37.62,12.83-10.56,30.04-10.84,38.45-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M120.79-30.54c8.3,10.08,4.77,26.7-7.89,37.12-12.66,10.42-29.64,10.69-37.94.61-8.3-10.08-4.77-26.7,7.89-37.12,12.66-10.42,29.64-10.69,37.94-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M120.47-30.27c8.19,9.94,4.7,26.34-7.78,36.62-12.48,10.28-29.24,10.55-37.43.61-8.19-9.94-4.7-26.34,7.78-36.62,12.48-10.28,29.24-10.55,37.43-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M120.14-30.01c8.07,9.81,4.64,25.98-7.68,36.11-12.31,10.14-28.84,10.41-36.92.6-8.07-9.81-4.64-25.98,7.68-36.11,12.31-10.14,28.84-10.41,36.92-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M119.82-29.74c7.96,9.67,4.57,25.62-7.57,35.61-12.14,10-28.44,10.26-36.4.59-7.96-9.67-4.57-25.62,7.57-35.61,12.14-10,28.44-10.26,36.4-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M119.5-29.47c7.85,9.54,4.51,25.26-7.46,35.11-11.97,9.86-28.04,10.12-35.89.58-7.85-9.54-4.51-25.25,7.46-35.11,11.97-9.86,28.04-10.12,35.89-.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 97.81,
    cy: -11.62,
    rx: 27.68,
    ry: 22.04,
    transform: "translate(29.68 59.52) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M118.86-28.94c7.63,9.26,4.38,24.53-7.25,34.11-11.63,9.57-27.24,9.83-34.87.56-7.63-9.26-4.38-24.53,7.25-34.11s27.24-9.83,34.87-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M118.54-28.68c7.51,9.13,4.32,24.17-7.14,33.61s-26.84,9.68-34.35.56c-7.51-9.13-4.32-24.17,7.14-33.61,11.46-9.43,26.84-9.68,34.35-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M118.22-28.41c7.4,8.99,4.25,23.81-7.04,33.1-11.29,9.29-26.44,9.54-33.84.55-7.4-8.99-4.25-23.81,7.04-33.1,11.29-9.29,26.44-9.54,33.84-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M117.9-28.15c7.29,8.85,4.19,23.45-6.93,32.6-11.12,9.15-26.04,9.39-33.33.54-7.29-8.85-4.19-23.45,6.93-32.6,11.12-9.15,26.04-9.39,33.33-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M117.57-27.88c7.18,8.72,4.12,23.09-6.82,32.1-10.95,9.01-25.64,9.25-32.81.53-7.18-8.72-4.12-23.09,6.82-32.1,10.95-9.01,25.64-9.25,32.81-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M117.25-27.62c7.07,8.58,4.06,22.73-6.72,31.6-10.77,8.87-25.24,9.1-32.3.52-7.06-8.58-4.06-22.73,6.72-31.6,10.77-8.87,25.24-9.1,32.3-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M116.93-27.35c6.95,8.45,3.99,22.37-6.61,31.1-10.6,8.73-24.84,8.96-31.79.51-6.95-8.45-3.99-22.37,6.61-31.1,10.6-8.73,24.84-8.96,31.79-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M116.61-27.09c6.84,8.31,3.93,22.01-6.5,30.6-10.43,8.59-24.44,8.82-31.28.51-6.84-8.31-3.93-22.01,6.5-30.6,10.43-8.59,24.43-8.81,31.28-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M116.29-26.82c6.73,8.17,3.86,21.65-6.4,30.09-10.26,8.45-24.03,8.67-30.76.5-6.73-8.17-3.86-21.65,6.4-30.1,10.26-8.45,24.03-8.67,30.76-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M115.97-26.56c6.62,8.04,3.8,21.29-6.29,29.59-10.09,8.31-23.63,8.53-30.25.49-6.62-8.04-3.8-21.29,6.29-29.59,10.09-8.31,23.63-8.53,30.25-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M115.65-26.29c6.5,7.9,3.74,20.93-6.18,29.09-9.92,8.17-23.23,8.38-29.74.48-6.5-7.9-3.74-20.93,6.18-29.09,9.92-8.17,23.23-8.38,29.74-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M115.33-26.02c6.39,7.76,3.67,20.56-6.08,28.59-9.75,8.03-22.83,8.24-29.23.47-6.39-7.76-3.67-20.56,6.08-28.59,9.75-8.03,22.83-8.24,29.23-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M115-25.76c6.28,7.63,3.61,20.2-5.97,28.09s-22.43,8.09-28.71.46c-6.28-7.63-3.61-20.2,5.97-28.09s22.43-8.09,28.71-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M114.68-25.49c6.17,7.49,3.54,19.84-5.86,27.59-9.41,7.74-22.03,7.95-28.2.46-6.17-7.49-3.54-19.84,5.86-27.59s22.03-7.95,28.2-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M114.36-25.23c6.06,7.36,3.48,19.48-5.76,27.09-9.24,7.6-21.63,7.8-27.69.45-6.06-7.36-3.48-19.48,5.76-27.09,9.24-7.6,21.63-7.8,27.69-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M114.04-24.96c5.94,7.22,3.41,19.12-5.65,26.58-9.06,7.46-21.23,7.66-27.17.44-5.94-7.22-3.41-19.12,5.65-26.58,9.06-7.46,21.23-7.66,27.17-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113.72-24.7c5.83,7.08,3.35,18.76-5.54,26.08-8.89,7.32-20.83,7.51-26.66.43-5.83-7.08-3.35-18.76,5.54-26.08,8.89-7.32,20.83-7.51,26.66-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M113.4-24.43c5.72,6.95,3.29,18.4-5.44,25.58-8.72,7.18-20.43,7.37-26.15.42-5.72-6.95-3.29-18.4,5.44-25.58,8.72-7.18,20.43-7.37,26.15-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M113.08-24.17c5.61,6.81,3.22,18.04-5.33,25.08s-20.03,7.23-25.64.41c-5.61-6.81-3.22-18.04,5.33-25.08,8.55-7.04,20.03-7.23,25.64-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M112.76-23.9c5.49,6.67,3.16,17.68-5.22,24.58-8.38,6.9-19.63,7.08-25.12.41-5.49-6.67-3.16-17.68,5.22-24.58s19.63-7.08,25.12-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M112.43-23.64c5.38,6.54,3.09,17.32-5.12,24.08-8.21,6.76-19.23,6.94-24.61.4-5.38-6.54-3.09-17.32,5.12-24.08,8.21-6.76,19.23-6.94,24.61-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M112.11-23.37c5.27,6.4,3.03,16.96-5.01,23.57-8.04,6.62-18.83,6.79-24.1.39-5.27-6.4-3.03-16.96,5.01-23.57,8.04-6.62,18.83-6.79,24.1-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M111.79-23.11c5.16,6.27,2.96,16.6-4.9,23.07-7.87,6.48-18.43,6.65-23.59.38-5.16-6.27-2.96-16.6,4.9-23.07,7.87-6.48,18.43-6.65,23.59-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M111.47-22.84c5.05,6.13,2.9,16.24-4.8,22.57-7.7,6.34-18.03,6.5-23.07.37-5.05-6.13-2.9-16.24,4.8-22.57,7.7-6.34,18.03-6.5,23.07-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M111.15-22.57c4.93,5.99,2.83,15.87-4.69,22.07-7.53,6.2-17.63,6.36-22.56.36-4.93-5.99-2.83-15.87,4.69-22.07,7.53-6.2,17.63-6.36,22.56-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M110.83-22.31c4.82,5.86,2.77,15.51-4.58,21.57-7.35,6.05-17.22,6.21-22.05.36-4.82-5.86-2.77-15.51,4.58-21.57,7.35-6.05,17.22-6.21,22.05-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M110.51-22.04c4.71,5.72,2.71,15.15-4.48,21.07-7.18,5.91-16.82,6.07-21.53.35-4.71-5.72-2.71-15.15,4.48-21.07,7.18-5.91,16.82-6.07,21.53-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M110.18-21.78c4.6,5.58,2.64,14.79-4.37,20.56-7.01,5.77-16.42,5.93-21.02.34-4.6-5.58-2.64-14.79,4.37-20.56,7.01-5.77,16.42-5.92,21.02-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M109.86-21.51c4.49,5.45,2.58,14.43-4.26,20.06-6.84,5.63-16.02,5.78-20.51.33-4.49-5.45-2.58-14.43,4.26-20.06,6.84-5.63,16.02-5.78,20.51-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M109.54-21.25c4.37,5.31,2.51,14.07-4.16,19.56-6.67,5.49-15.62,5.64-20,.32-4.37-5.31-2.51-14.07,4.16-19.56,6.67-5.49,15.62-5.64,20-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M109.22-20.98c4.26,5.18,2.45,13.71-4.05,19.06-6.5,5.35-15.22,5.49-19.48.32-4.26-5.18-2.45-13.71,4.05-19.06,6.5-5.35,15.22-5.49,19.48-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M108.9-20.72c4.15,5.04,2.38,13.35-3.94,18.56-6.33,5.21-14.82,5.35-18.97.31-4.15-5.04-2.38-13.35,3.94-18.56,6.33-5.21,14.82-5.35,18.97-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M108.58-20.45c4.04,4.9,2.32,12.99-3.84,18.06-6.16,5.07-14.42,5.2-18.46.3-4.04-4.9-2.32-12.99,3.84-18.06,6.16-5.07,14.42-5.2,18.46-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.26-20.19c3.92,4.77,2.25,12.63-3.73,17.56-5.99,4.93-14.02,5.06-17.95.29-3.93-4.77-2.25-12.63,3.73-17.56,5.99-4.93,14.02-5.06,17.95-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M107.94-19.92c3.81,4.63,2.19,12.27-3.62,17.05-5.81,4.79-13.62,4.91-17.43.28-3.81-4.63-2.19-12.27,3.62-17.05,5.81-4.79,13.62-4.91,17.43-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M107.61-19.66c3.7,4.5,2.13,11.91-3.52,16.55-5.64,4.65-13.22,4.77-16.92.27-3.7-4.5-2.13-11.91,3.52-16.55,5.64-4.65,13.22-4.77,16.92-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M107.29-19.39c3.59,4.36,2.06,11.55-3.41,16.05-5.47,4.51-12.82,4.62-16.41.27-3.59-4.36-2.06-11.55,3.41-16.05,5.47-4.51,12.82-4.62,16.41-.27Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "62.71 9.55 60.98 9.55 60.98 2.33 68.2 2.33 68.2 4.06 62.71 4.06 62.71 9.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "98.21 9.55 96.48 9.55 96.48 4.06 90.99 4.06 90.99 2.33 98.21 2.33 98.21 9.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "98.21 49.92 90.99 49.92 90.99 48.19 96.48 48.19 96.48 42.7 98.21 42.7 98.21 49.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "68.2 49.92 60.98 49.92 60.98 42.7 62.71 42.7 62.71 48.19 68.2 48.19 68.2 49.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "71.78 31.25 70.55 35.9 70.47 35.88 71.7 31.23 71.78 31.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "70.64 36.04 70.31 35.98 71.61 31.09 71.94 31.16 70.64 36.04"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "75.95 30.69 71.74 31.3 71.75 31.18 75.96 30.57 75.95 30.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "71.6 31.45 71.63 31.07 76.09 30.43 76.07 30.8 71.6 31.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "81.03 36.24 76.27 39.22 76.25 39.12 81.01 36.14 81.03 36.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.19 39.42 76.11 39.06 81.09 35.94 81.17 36.3 76.19 39.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "84.88 38.51 84.83 38.62 80.99 36.25 81.05 36.14 84.88 38.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "84.89 38.8 80.83 36.29 80.99 35.96 85.04 38.46 84.89 38.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "82.23 31.46 81.06 36.2 80.98 36.18 82.14 31.45 82.23 31.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "81.16 36.34 80.82 36.28 82.05 31.3 82.38 31.36 81.16 36.34"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M81.09,35.77c.17,0,.28.2.24.43s-.21.41-.38.41c-.17,0-.28-.2-.24-.43.04-.23.21-.41.38-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M80.96,36.73s0,0-.01,0c-.1,0-.19-.05-.26-.13-.09-.11-.13-.27-.1-.44.05-.29.26-.52.51-.51h0c.1,0,.19.05.26.13.09.11.13.27.1.44-.05.29-.27.51-.5.51ZM81.08,35.9c-.09,0-.22.12-.25.3-.02.1,0,.19.04.24.02.03.05.04.08.04,0,0,0,0,0,0,.09,0,.22-.12.25-.3.02-.1,0-.19-.04-.24-.02-.03-.05-.04-.08-.04,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M79.82,27.51c.17,0,.28.2.24.43s-.21.41-.38.41-.28-.2-.24-.43c.04-.23.21-.41.38-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M79.68,28.47s0,0-.01,0c-.1,0-.19-.05-.26-.13-.09-.11-.12-.27-.1-.44.05-.29.27-.51.5-.51,0,0,0,0,.01,0,.1,0,.19.05.26.13.09.11.12.27.1.44-.05.29-.27.51-.5.51ZM79.81,27.64c-.09,0-.22.12-.25.3-.02.1,0,.19.04.24.02.03.05.04.08.04,0,0,0,0,0,0,.09,0,.22-.12.25-.3.02-.1,0-.19-.04-.24-.02-.03-.05-.04-.08-.04h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M71.81,30.82c.17,0,.28.2.24.43-.04.23-.21.41-.38.41-.17,0-.28-.2-.24-.43.04-.23.21-.41.38-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M71.68,31.78s0,0-.01,0c-.1,0-.19-.05-.26-.13-.09-.11-.13-.27-.1-.44.05-.29.27-.51.51-.51h0c.1,0,.19.05.26.13.09.11.12.27.1.44-.05.29-.27.51-.5.51ZM71.81,30.95c-.09,0-.22.12-.25.3-.02.1,0,.19.04.24.02.03.05.04.07.04,0,0,0,0,0,0,.09,0,.22-.12.25-.3.02-.1,0-.19-.04-.24-.02-.03-.05-.04-.08-.04,0,0,0,0,0,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.32 39.17 76.26 39.31 70.47 35.89 70.53 35.75 76.32 39.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.32 39.49 70.31 35.94 70.47 35.58 76.48 39.12 76.32 39.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.02 30.72 70.52 35.88 70.47 35.77 75.97 30.61 76.02 30.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "70.48 36.09 70.32 35.73 76.01 30.4 76.17 30.75 70.48 36.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.35 39.22 76.24 39.26 75.94 30.69 76.05 30.65 76.35 39.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.12 39.43 75.81 30.6 76.17 30.48 76.48 39.31 76.12 39.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "82.26 31.58 76.33 39.29 76.26 39.19 82.19 31.49 82.26 31.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.32 39.49 76.1 39.19 82.19 31.28 82.42 31.58 76.32 39.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "82.24 31.46 82.21 31.61 75.98 30.74 76.01 30.6 82.24 31.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "82.3 31.75 75.83 30.85 75.92 30.46 82.39 31.36 82.3 31.75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "79.86 45.66 79.76 45.77 76.24 39.29 76.34 39.19 79.86 45.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "79.73 45.98 76.09 39.27 76.37 38.98 80.01 45.68 79.73 45.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "84.8 38.68 76.28 39.31 76.3 39.17 84.82 38.54 84.8 38.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "76.14 39.45 76.19 39.05 84.96 38.4 84.91 38.8 76.14 39.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "84.86 38.57 84.76 38.65 82.17 31.58 82.27 31.49 84.86 38.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "84.7 38.86 82.03 31.54 82.33 31.28 85.01 38.61 84.7 38.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "84.85 38.65 79.85 45.76 79.77 45.67 84.77 38.57 84.85 38.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "79.86 45.96 79.61 45.68 84.76 38.36 85 38.65 79.86 45.96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "88.56 30.59 82.22 31.61 82.22 31.46 88.56 30.44 88.56 30.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "82.1 31.75 82.1 31.36 88.68 30.3 88.69 30.69 82.1 31.75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "88.61 30.54 84.85 38.64 84.76 38.58 88.51 30.49 88.61 30.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "84.91 38.81 84.6 38.63 88.46 30.31 88.77 30.49 88.72 30.59 84.91 38.81"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M70.6,35.31c.21,0,.34.24.29.52-.05.28-.26.51-.47.5-.21,0-.34-.24-.29-.52.05-.28.26-.51.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M70.43,36.46s0,0-.01,0c-.12,0-.22-.06-.3-.15-.11-.13-.15-.32-.11-.52.06-.35.32-.61.59-.61.12,0,.22.06.3.15.11.13.15.32.11.52-.06.34-.31.61-.58.61ZM70.59,35.43c-.13,0-.3.16-.34.4-.02.13,0,.25.06.32.03.04.07.06.11.06,0,0,0,0,0,0,.13,0,.3-.16.34-.4.02-.13,0-.25-.06-.32-.03-.04-.07-.06-.11-.06h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M76.35,38.66c.21,0,.34.24.29.52-.05.28-.26.51-.47.5-.21,0-.34-.24-.29-.52.05-.28.26-.51.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M76.18,39.81s0,0-.01,0c-.12,0-.22-.06-.3-.15-.11-.13-.15-.32-.11-.52.06-.35.32-.62.59-.61h0c.12,0,.22.06.3.15.11.13.15.32.11.52-.06.34-.31.61-.58.61ZM76.34,38.78c-.13,0-.3.16-.34.4-.02.13,0,.25.06.32.03.04.07.06.11.06.13.01.3-.16.34-.4.02-.13,0-.25-.06-.32-.03-.04-.07-.06-.11-.06h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M76.06,30.1c.21,0,.34.24.29.52-.05.28-.26.51-.47.5-.21,0-.34-.24-.29-.52.05-.28.26-.51.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M75.89,31.25s0,0-.01,0c-.12,0-.22-.06-.3-.15-.11-.13-.15-.32-.11-.52.06-.34.31-.61.58-.61,0,0,0,0,.01,0h0c.12,0,.22.06.3.15.11.13.15.32.11.52-.06.34-.31.61-.58.61ZM76.05,30.22c-.13,0-.3.16-.34.4-.02.13,0,.25.06.32.03.04.07.06.11.06.12,0,.3-.16.34-.4.02-.13,0-.25-.06-.32-.03-.04-.07-.06-.11-.06h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M82.27,30.94c.21,0,.34.24.29.52-.05.28-.26.51-.47.5s-.34-.24-.29-.52c.05-.28.26-.51.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M82.11,32.09s0,0-.01,0c-.12,0-.22-.06-.3-.15-.11-.13-.15-.32-.11-.52.06-.34.31-.61.58-.61,0,0,0,0,.01,0h0c.12,0,.22.06.3.15.11.13.15.32.11.52-.06.34-.31.61-.58.61ZM82.27,31.07c-.13,0-.3.16-.34.4-.02.13,0,.25.06.32.03.04.07.06.11.06,0,0,0,0,0,0,.13,0,.3-.16.34-.4.02-.13,0-.25-.06-.32-.03-.04-.07-.06-.11-.06h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M79.89,45c.21,0,.34.24.29.52-.05.28-.26.51-.47.5s-.34-.24-.29-.52c.05-.28.26-.51.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M79.72,46.15s0,0-.01,0c-.12,0-.22-.06-.3-.15-.11-.13-.15-.32-.11-.52.06-.35.31-.62.59-.61.12,0,.22.06.3.15.11.13.15.32.11.52-.06.34-.31.61-.58.61ZM79.88,45.13c-.13,0-.3.16-.34.4-.02.13,0,.25.06.32.03.04.07.06.11.06,0,0,0,0,0,0,.13,0,.3-.16.34-.4.02-.13,0-.25-.06-.32-.03-.04-.07-.06-.11-.06,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M84.9,38.02c.21,0,.34.24.29.52s-.26.51-.47.5-.34-.24-.29-.52c.05-.28.26-.51.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M84.74,39.17s0,0-.01,0c-.12,0-.22-.06-.3-.15-.11-.13-.15-.32-.11-.52.06-.34.31-.61.58-.61,0,0,0,0,.01,0h0c.12,0,.22.06.3.15.11.13.15.32.11.52-.06.34-.31.61-.58.61ZM84.9,38.15c-.13,0-.3.16-.34.4-.02.13,0,.25.06.32.03.04.07.06.11.06,0,0,0,0,0,0,.13,0,.3-.16.34-.4.02-.13,0-.25-.06-.32-.03-.04-.07-.06-.11-.06h0s0,0,0,0Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M80.82,33.88c.26.32.22.79-.1,1.05s-.79.22-1.05-.1-.22-.79.1-1.05.79-.22,1.05.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M80.25,35.22s-.06,0-.09,0c-.23-.02-.44-.13-.59-.31-.15-.18-.22-.41-.19-.64s.13-.44.31-.59c.37-.3.92-.25,1.22.12h0c.3.37.25.92-.12,1.22-.16.13-.35.2-.55.2ZM80.25,33.73c-.14,0-.28.05-.39.14-.13.11-.21.25-.22.42-.02.16.03.33.14.45.11.13.25.21.42.22.17.02.33-.03.45-.14.26-.22.3-.61.08-.87-.12-.15-.3-.23-.48-.23Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M76.54,30.96s-.02-.06-.02-.09c-.14-.6-.83-3.05.62-7.38.27-.8-.26-.5-.64.11-.25.41-1.64,3.33-1.21,7.42.04,0,.09,0,.13,0,.37-.04.75-.06,1.13-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M74.09,31.04c.19,0,.39,0,.58,0-.27-1.21-.51-3.08-.05-5.18.16-.74-.25-.54-.64.43-.24.6-.72,2.36-.45,4.75,0,0,.01,0,.02,0,.18,0,.35,0,.53,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M87.2,30.84c.22.01.44.03.66.05-.11-.84-.35-1.74-.75-2.72-.35-.85-.81-.71-.49.02.12.27.51,1.27.58,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M86.43,30.83c-.05-.61-.16-1.21-.34-1.76-.22-.64-.51-.4-.41.27.06.43.1.95.09,1.52.22-.01.44-.03.66-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M72.14,30.85c-.36-2.15.15-4.13,1.26-5.78.71-1.06,1.18-2.03,1.24-3.15.12-2.06.3-3.55,1.6-5.43,1.31-1.88.34-2.71,1.15-4.72.82-2,1.99-2.35,2.22-2.68.33-.47.53-1.83.55-2.17.01-.27.19-.18.25.02.07.27.16,1.03-.18,2.01-.12.35-.07.67.33.02.43-.7.47-1.82.02-2.65-.36-.66-.59-.53-.92-.09-.19.26-.85,1.44-1.08,2.57-.07.36-1.81,1.21-2.11,4.65-.23,2.67-1.36,2.56-2.2,5.48-.81,2.8.05,3.33-1.78,6.04-1.17,1.74-1.53,3.74-1.33,5.75.33.03.66.07.99.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M83.65,20.21c-.2.3-1.68,2.33-2.59,7.84-.11.65-.4.72-.41.05-.01-.92-.02-3.45,1.23-6.87.34-.94-.15-.75-.63.02-.51.82-1.95,3.32-2.35,7.94-.05.54-.35.79-.45.14-.05-.32-.32-3.11.87-6.97.28-.9-.38-.34-.63.15-.22.45-1.93,3.65-1.73,8.13,0,.13,0,.23-.02.32.54,0,1.09.03,1.63.06.22,0,.45,0,.67,0,1.13-.63,2.33-1.02,3.34-1.75,2.02-1.45,2.96-5.05,2.03-7.49-.11-.3.03-.42.27-.08.19.28,1.67,2.21.26,5.87-.26.67.14.47.39.02.26-.48,2.37-4.26-1.19-7.59-.31-.3-.51-.08-.7.21ZM82.56,28.37c-.16-.01.27-1.27.59-1.19.47.13-.37,1.21-.59,1.19ZM84.09,22.92c.14.84,0,2.32-.32,2.99-.31.68-.63.64-.43-.11.27-1.01.47-2.03.37-2.94-.08-.69.24-.79.38.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M79.21,13.31c.17-.67.89-3.67.25-2.59-.88,1.47-1.22,3.86-1.27,2.63-.03-.7.21-1.58.16-1.7-.19-.4-1.21,1.73-.6,3.56.07.21,1.19,0,2.17-1.18,1.23-1.48,1.34-3.08,1.5-3.51.12-.33.42,1.03-.18,2.65-.21.57-.29,1.18.28.29.4-.62,1.19-2.2.14-3.77-.23-.34-.63-.66-.82.16-.51,2.12-1.97,4.89-1.62,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M79.69,19.29c-.34-2.6,1.07-4.78.79-4.53-1.83,1.57-2.48,5.69-2.53,5.27-.26-2.09.95-4.4.48-3.97-1.36,1.23-1.94,5.33-2.06,4.54-.16-1.08.76-3.72.37-3.3-2.02,2.17-1.03,5.03-.73,4.74.85-.84,3.67-1.13,5.25-2.84,1.74-1.87,1.18-4.75,1.38-4.48,1.33,1.91-.36,4.68-.36,4.68,3.46-2.81.37-6,.1-5.74-2.02,2-2.64,5.95-2.68,5.64ZM81.22,17.62c.32-.63.47-1.07.6-1.84.09-.53.37-.67.34.13-.03.61-.34,1.45-.68,2.03-.36.6-.7.55-.25-.32ZM80.47,19.11c.04-.15.36-.71.49-.44.16.32-.56.73-.49.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M84.28,30.28c0,.15,0,.4-.01.74.2-.03.4-.05.6-.08-.02-.3-.06-.6-.12-.9-.12-.6-.46-.52-.47.24Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 56.97,
    y: 30.21,
    width: 46.07,
    height: 1.42
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M33.25,64.81v3.56c0,1,.18,2.05.56,3.1l2.53,7.7,2.56-7.7c.38-1.15.56-2.2.56-3.1v-3.56h2.76v3.33c0,1.41-.2,2.74-.64,4.02l-3.45,10.16h-3.58l-3.43-10.16c-.44-1.28-.64-2.61-.64-4.02v-3.33h2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M56.56,64.81v12.9c0,1.15.92,2.07,2.07,2.07h1.23c1.15,0,2.07-.92,2.07-2.07v-12.9h2.76v12.9c0,1.33-.49,2.48-1.43,3.43-.95.95-2.07,1.41-3.4,1.41h-1.23c-1.36,0-2.48-.46-3.43-1.41s-1.41-2.1-1.41-3.43v-12.9h2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M77.19,64.81h10.59v2.76h-7.83v4.61h7.06v2.76h-7.06v4.61h7.83v2.76h-10.59v-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M103.06,64.81v14.74h7.6v2.76h-10.36v-17.5h2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M133.46,64.81v2.76h-4.22v14.74h-2.76v-14.74h-4.22v-2.76h11.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M156.14,75.25c.13.64.49,2.18.49,3.76v3.3h-2.76v-3.79h-6.22v3.79h-2.76v-3.3c0-1.61.33-3.12.46-3.76l.05-.23,2.28-8.14c.38-1.33,1.64-2.3,3.07-2.3s2.69.95,3.1,2.3l2.25,8.14.05.23ZM153.4,75.77s-.03-.1-.03-.13l-2.18-7.96c-.08-.23-.23-.33-.46-.33-.26,0-.41.1-.46.33l-2.18,7.96s-.03.1-.03.13h5.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M3.37,69.39h3.21c.73,0,1.36.26,1.86.78.52.5.78,1.13.78,1.87v5.12c0,.75-.26,1.37-.78,1.89s-1.13.76-1.86.76h-3.21v-10.42ZM6.58,79.07c.53,0,.97-.18,1.34-.55.38-.38.56-.84.56-1.37v-5.12c0-.53-.18-.99-.56-1.36-.37-.38-.81-.56-1.34-.56h-2.48v8.96h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M15.6,69.39h5.85v.73h-5.12v4.11h4.65v.73h-4.65v4.11h5.12v.73h-5.85v-10.42Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M38.39,103.31v2h-.73v-2c0-.08-.02-.3-.03-.69h-4.74c-.03.29-.05.52-.05.69v2h-.73v-2c0-.67.09-1.4.27-2.19l1.45-5.29c.17-.62.75-1.08,1.42-1.08s1.25.46,1.42,1.08l1.45,5.29c.18.69.27,1.42.27,2.19ZM37.52,101.89c-.02-.17-.06-.35-.12-.58l-1.43-5.27c-.12-.73-1.31-.73-1.43,0l-1.43,5.27c-.06.23-.11.41-.12.58h4.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M55.86,94.89c-.18-.95-1.02-1.66-2.02-1.66h-1.23c-1.15,0-2.07.95-2.07,2.07v8.29c0,1.15.92,2.07,2.07,2.07h1.23c1,0,1.84-.74,2.02-1.66l2.66.77c-.28,1.05-.84,1.94-1.71,2.64-.87.69-1.87,1.02-2.97,1.02h-1.23c-1.36,0-2.48-.46-3.43-1.41s-1.41-2.1-1.41-3.43v-8.29c0-1.33.46-2.46,1.41-3.4.95-.95,2.07-1.43,3.43-1.43h1.23c1.1,0,2.1.36,2.97,1.05.87.69,1.43,1.56,1.71,2.61l-2.66.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M81.33,101.13c.13.64.49,2.18.49,3.76v3.3h-2.76v-3.79h-6.22v3.79h-2.76v-3.3c0-1.61.33-3.12.46-3.76l.05-.23,2.28-8.14c.38-1.33,1.64-2.3,3.07-2.3s2.69.95,3.1,2.3l2.25,8.14.05.23ZM78.59,101.64s-.03-.1-.03-.13l-2.18-7.96c-.08-.23-.23-.33-.46-.33-.26,0-.41.1-.46.33l-2.18,7.96s-.03.1-.03.13h5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M95.61,104c.18.95,1.05,1.66,2.05,1.66h1.74c1.13,0,2.07-.92,2.07-2.07s-.69-2.05-2.07-2.58l-2.18-.82c-2.58-1.02-3.89-2.66-3.89-4.89,0-1.36.46-2.48,1.41-3.43s2.1-1.41,3.43-1.41h1.2c1.13,0,2.12.33,2.99,1.02.87.69,1.43,1.56,1.69,2.61l-2.66.77c-.18-.92-1.02-1.64-2.02-1.64h-1.2c-1.15,0-2.07.92-2.07,2.07,0,1,.44,1.64,2.18,2.33l2.2.84c2.35.95,3.76,2.76,3.76,5.12,0,1.36-.49,2.48-1.43,3.43s-2.07,1.41-3.4,1.41h-1.74c-1.13,0-2.12-.33-2.99-1.02-.87-.69-1.43-1.59-1.69-2.64l2.64-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M127.08,101.13c.13.64.49,2.18.49,3.76v3.3h-2.76v-3.79h-6.22v3.79h-2.76v-3.3c0-1.61.33-3.12.46-3.76l.05-.23,2.28-8.14c.38-1.33,1.64-2.3,3.07-2.3s2.69.95,3.1,2.3l2.25,8.14.05.23ZM124.35,101.64s-.03-.1-.03-.13l-2.18-7.96c-.08-.23-.23-.33-.46-.33-.26,0-.41.1-.46.33l-2.18,7.96s-.03.1-.03.13h5.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAssets02);
export default __webpack_public_path__ + "static/media/SVG_assets-02.ee36b3170d6390fc67cc951874d35c8e.svg";
export { ForwardRef as ReactComponent };